import { Form, Formik, FormikProps } from "formik";
import React, { useEffect, useRef, useState } from "react";
import FormObserver from "../FormElements/FormObserver";
import { FormDateSelector } from "../FormElements";
import { Button } from "../Elements";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import { DateSelectorRefProps } from "../FormElements/FormDate";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { clearState, getBookingList } from "../../../store/slices/sabeeappBookingListSlice";
import { cronJobValidationScheme } from "../../../common/validators/sabeeAppBookingFilterScheme";
import { FilterFormProps } from "../../../common/types";
import { buttonTexts } from "../../../constants/texts/buttonTexts";

const initialValues = {
    dateRange: {
        startDate: null,
        endDate: null,
    },
}

type Props = {
    isOpen: boolean,
    setFiltersIsOpen: (isOpen: boolean) => void
}
const Filters = ({ isOpen, setFiltersIsOpen }: Props) => {

    const formref = useRef<FormikProps<FilterFormProps>>(null);
    const dateRangeRef = useRef<DateSelectorRefProps>(null);
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const [formValues, setFormValues] = useState(initialValues);

    useEffect(() => {
        dispatch(clearState());
    }, []);

    function submitform() {
        formref.current?.submitForm();
    }

    const onSubmit = async (values: FilterFormProps) => {


        var start = values.dateRange.startDate;
        var end = values.dateRange.endDate;
        var startDate = "";
        var endDate = "";
        if (start) {
            startDate = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear();
        }
        if (end) {
            endDate = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear();
        }

        const parameters = {
            timeStart: startDate,
            timeEnd: endDate,
        };



        dispatch(getBookingList(parameters));

        setFiltersIsOpen(false);

    };


    const fields = [
        { key: "dateRange", label: "Tarih Aralığı", type: "object", datatype: "daterange" },

    ];

    const resetDateRanges = (value: any) => {
        var keys = Object.keys(value);

        if (keys && keys.length > 0) {
            if (keys[0] == "dateRange") {
                dateRangeRef.current?.resetForm();
            }
        }
    }

    const onUpdate = (value: FilterFormProps) => {
        setFormValues(Object.assign(formValues, value));
        resetDateRanges(value);
        submitform();
    };
    const clearFilters = () => {
        formref.current?.resetForm()

        dispatch(updateIsResetForm(true));
        setTimeout(() => {
            dispatch(updateIsResetForm(false));
        }, 1000);
        submitform();
    };

    return (
        <Formik
            innerRef={formref}
            initialValues={initialValues}
            onSubmit={onSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            validate={cronJobValidationScheme}
        >
            {({
                values,
                touched,
                errors,
            }) => (
                <Form>
                    <FormObserver
                        watch={(val: FilterFormProps) => {
                            setFormValues(val);
                        }}
                    />
                    <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`}>
                        <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-4 xl:grid-cols-4 ">

                            <div className="">
                                <FormDateSelector
                                    label="Tarih Aralığı"
                                    name="dateRange"
                                    type="range"
                                    ref={dateRangeRef}
                                    nullable
                                />
                            </div>
                        </div>

                        <div className="flex justify-end mt-2 mr-0">
                            <Button
                                type="button"
                                color="gray"
                                hover="gray"
                                size="xs"
                                className="mr-3"
                                callback={clearFilters}
                            >
                                Tüm Alanları Temizle
                            </Button>
                            <Button type="submit" color="primary" hover="primary" size="xs">
                                <img src="/icons/prepare-white.svg" alt="prepare" />
                                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
                            </Button>
                        </div>
                    </div>
                    <div className={`m-4 px-4 py-3 bg-white shadow-md ${isOpen ? "hidden" : ""}`} >
                        <FormFiltersShortList
                            formValues={{ ...values }}
                            fields={fields}
                            initialValues={initialValues}
                            callback={(val: FilterFormProps) => onUpdate(val)}
                            clearFilter={() => {
                                clearFilters()
                                submitform();
                            }}

                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
}
export default Filters;